import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const points = [
    "Senior engineers who care about craft and clarity",
    "Calm, predictable delivery using agile rituals",
    "Modern architecture built to scale with your business",
    "Long-term partnership beyond go-live",
];

export default function About({ variant = "section" }) {
    return (
        <section
            data-testid="about-section"
            id="about"
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5">
                    <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                        About Thooyra
                    </div>
                    <h2 className="font-display font-light text-4xl md:text-5xl tracking-tighter leading-tight">
                        A Chennai-based engineering studio building software
                        that businesses{" "}
                        <span className="italic font-medium">actually use</span>
                        .
                    </h2>
                </div>

                <div className="lg:col-span-7 lg:pt-4">
                    <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
                        We partner with founders, CTOs and operations leaders
                        to turn complex business problems into clean, modern
                        software. From a first prototype to a multi-tenant SaaS
                        platform, our team brings senior engineering depth,
                        product taste and a calm delivery process.
                    </p>

                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
                        {points.map((p, i) => (
                            <motion.div
                                key={p}
                                initial={{ opacity: 0, y: 12 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.06 }}
                                className="flex items-start gap-3"
                            >
                                <CheckCircle2 className="h-5 w-5 mt-0.5 text-foreground" />
                                <span className="text-sm md:text-base">
                                    {p}
                                </span>
                            </motion.div>
                        ))}
                    </div>

                    <div className="mt-12 grid grid-cols-3 gap-6">
                        {[
                            { k: "40+", v: "Projects shipped" },
                            { k: "12+", v: "Industries served" },
                            { k: "98%", v: "Client retention" },
                        ].map((s) => (
                            <div
                                key={s.v}
                                className="border-t border-border pt-4"
                            >
                                <div className="font-display text-3xl md:text-4xl tracking-tighter">
                                    {s.k}
                                </div>
                                <div className="text-xs md:text-sm text-muted-foreground mt-1">
                                    {s.v}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
